import type {Context} from '../types';

export default (context: Context) => {
  const {jsonNode} = context.node;
  const {data = {}} = jsonNode;

  const hasAlt = data?.attr && data.attr.hasOwnProperty('alt');
  const alt = data?.attr?.alt;

  // This patch is needed for `null` and `''` valued alt text data on
  // Image nodes, if there is a dynamio binding on the alt text we don't
  // need it.
  const needed =
    jsonNode.type === 'Image' &&
    (alt == null || alt === '') &&
    !data?.dyn?.bind?.alt;

  return {
    needed,
    logData: {
      msg: 'Convert Image alt data from Custom type to Alias type',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      data.attr = data.attr || {};
      // The "inherit" option is the default, the node value for that is `null`
      // normally we trim out `null` values from the db nodes but for
      // extra security we check that also
      if (!hasAlt) {
        data.attr.alt = '__wf_reserved_inherit';
      }
      if (hasAlt) {
        if (alt == null) {
          data.attr.alt = '__wf_reserved_inherit';
        } else if (alt === '') {
          // "decorative" option is represented as an empty string in the db
          data.attr.alt = '__wf_reserved_decorative';
        }
      }
    },
  };
};
